import { useTranslation } from 'react-i18next'

import { Gender } from '@/common/models/person'
import { UserType } from '@/common/models/user'
import { validateCPF } from '@/common/utils/validateCPF'
import { z } from '@/lib/zod'

export function EditUserSchema() {
  const { t } = useTranslation('registers')

  return z
    .object({
      email: z.string().email(),
      userType: z.nativeEnum(UserType),
      documentNumber: z.string().min(2).max(100),
      displayName: z.string().min(2).max(100),
      isForeign: z.boolean().optional().default(false),
      name: z.string().min(2).max(100),
      birthDate: z.date(),
      genre: z.nativeEnum(Gender),
      editAllowedPosts: z.boolean().optional().default(false),
    })
    .refine(
      (data) => {
        if (!data.isForeign) {
          const cleanCPF = data.documentNumber.replace(/\D/g, '')
          if (cleanCPF.length !== 11) {
            return false
          }
          return validateCPF(cleanCPF)
        }

        return data.documentNumber.length > 0
      },
      {
        message: t('users.drawer_edit_user.schema.document.invalid'),
        path: ['documentNumber'],
      },
    )
}

export type EditUserForm = z.infer<ReturnType<typeof EditUserSchema>>
